<template>
	<section class="pre-footer">
		<div class="row">
			<div class="columns column5 align-left">
				<div class="pre-footer-wrapper">
					<div class="inner-wrapper">
						<h2>{{ footerSection.header }}</h2>
						<div v-parse-links v-html="footerSection.content" />
					</div>
				</div>
			</div>
		</div>
		<picture>
			<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
			<source :srcset="footerSection.image" />
			<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pre-footer {
	position: relative;

	h2 {
		color: #fff;
	}

	.small-row {
		max-width: 740px;
	}

	&::before {
		position: absolute;
		inset: 0;
		content: '';
		display: block;
		z-index: 2;
		background: rgb(0 0 0 / 30%);
	}

	.column5 {
		background: none;
		color: #fff;
		padding: 50px;
		margin: 150px auto;
		z-index: 3;
	}
}

.pre-footer-wrapper {
	background: rgb(12 39 67 / 70%);
	backdrop-filter: blur(24px);
	padding: 15px;

	.inner-wrapper {
		padding: 35px;
		width: 100%;
		height: 100%;
		border: 2px solid #fff;
	}

	h2,
	h4 {
		color: #ffe276;
	}
}

.bg-image {
	position: absolute;
	inset: 0;
	height: 100%;
	width: 100%;
	object-fit: cover;
	z-index: 1;
}

@media (max-width: 800px) {
	.pre-footer .column5 {
		margin: 80px auto;
	}
}

@media (max-width: 600px) {
	.pre-footer .column5 {
		margin: 50px auto;
	}

	.pre-footer-wrapper {
		padding: 12px;

		.inner-wrapper {
			padding: 25px;
		}
	}
}
</style>
